<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图" />
    </div>
    <p class="title">广州意澳文化传播有限公司</p>
    <p class="address_tel_fax">
      <span>地址：广州市海珠区上冲南约46号</span>
      <span>Tel：020-89578031</span>
      <!-- <span>Fax：8888-88888888</span> -->
    </p>
    <p class="email_wx">
      <span>邮箱：smartwork666@163.com</span>
      <!-- <span>公司微信号：ilyk_gg</span> -->
    </p>
    <p class="copy">
      Copyright &copy; 2023 广州意澳文化传播有限公司
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="text-decoration:none;color:#d3d3d3;"
        >粤ICP备2021173975号-2</a
      >
    </p>
    <div style="width:300px;margin:0 auto; padding:0px 0 5px;">
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010502002525"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        ><img src="@/assets/img/gongan.png" style="float:left;" />
        <p
          style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
        >
          粤公网安备 44010502002525号
        </p></a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 30px 0 0px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue